module.exports = __webpack_public_path__ + "static/media/admin-1.a73a3e20.jpg";